import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let AutocompleteComp;

class Autocomplete extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: AutocompleteComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/lyte-components/autocomplete-comp" */
      "../../../components/javascript/lyte-components/autocomplete-comp"
    ).then(function(res) {
      AutocompleteComp = res.AutocompleteComp;
    }));

    
;
  }
}

export { Autocomplete };
